export const breadcrumbsConfig = {
    name: 'Breadcrumbs',
    category: 'Zapier Blocks',
    image: 'https://cdn.zappy.app/653acedb1f8b80db6aaadb39f0c2d7c7.svg',
    inputs: [
        {
            name: 'links',
            type: 'list',
            subFields: [
                { name: 'text', type: 'string', required: true },
                { name: 'href', type: 'string', required: true },
            ],
        },
        {
            name: 'currentPage',
            type: 'string',
        },
        {
            name: 'size',
            type: 'string',
            enum: ['small', 'large'],
        },
    ],
};
//# sourceMappingURL=config.js.map